import ProspectorProApiService from './ProspectorProApiService';

export default class ProspectService extends ProspectorProApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.getByKeyUrl = '/ProspectREST/prospect-by-key';
    this.getAllUrl = '/ProspectREST/prospects-for-agent';
    this.updateUrl = '/ProspectREST/update-prospect';
  }

  getByOaId(identifier) {
    return this.get('/ProspectREST/get-by-oaagentid', {}, identifier);
  }

  getStatsForAgent(identifier, data) {
    return this.get('/ProspectREST/prospect-stats-for-agent', data, identifier);
  }

  getProspectsForAgentByStage(identifier, data) {
    return this.get('/ProspectREST/prospects-with-stage-for-agent', data, identifier);
  }

  getAllTimeProspectsForAgentByStage(identifier, data) {
    return this.get('/ProspectREST/prospects-all-time-for-agent', data, identifier);
  }

  getProspectsForAgentByReminder(identifier, data) {
    return this.get('/ProspectREST/prospects-with-reminders-for-agent', data, identifier);
  }

  getProspectsForAgentByActivity(identifier, data) {
    return this.get('/ProspectREST/prospects-with-activity-for-agent', data, identifier);
  }

  update(data, identifier, fullResponse) {
    return this.putRaw(this.updateUrl, data, identifier, fullResponse);
  }

  createStage(data) {
    return this.postRaw('/ProspectREST/create-prospect-stage', data);
  }

  createReminder(data) {
    return this.postRaw('/ProspectREST/create-prospect-reminder', data);
  }

  updateReminder(data) {
    return this.putRaw('/ProspectREST/update-prospect-reminder', data);
  }

  createStatus(data) {
    return this.postRaw('/ProspectREST/create-prospect-status', data);
  }
}
